// extracted by mini-css-extract-plugin
module.exports = {"text":"bodyCopySkins-increasedLineHeight-text-c7369cc8"};